import { faro, getWebInstrumentations, initializeFaro, LogLevel } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { env } from '$env/dynamic/public';

// Grafana Faro is the only telemetry in the SPA and is off unless PUBLIC_FARO_URL is set. Fetch calls to the
// same-origin API carry a W3C traceparent, so a click, the .NET request and its SQL show up as one trace.
// Only ids are sent about the user (never emails).
export function initTelemetry() {
	if (!env.PUBLIC_FARO_URL) return;

	initializeFaro({
		url: env.PUBLIC_FARO_URL,
		app: {
			name: 'madplan-web',
			version: env.PUBLIC_APP_VERSION || undefined,
			environment:
				env.PUBLIC_FARO_ENVIRONMENT || (import.meta.env.DEV ? 'development' : 'production')
		},
		sessionTracking: { samplingRate: Number(env.PUBLIC_FARO_SAMPLE_RATE ?? 1) },
		consoleInstrumentation: {
			disabledLevels: [LogLevel.TRACE, LogLevel.DEBUG, LogLevel.LOG, LogLevel.INFO]
		},
		instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()]
	});
}

export function identify(userId: string, householdId: string | null) {
	faro.api?.setUser({ id: userId, attributes: { household_id: householdId ?? 'none' } });
}

export function forgetUser() {
	faro.api?.resetUser();
}

export function reportError(error: unknown) {
	faro.api?.pushError(error instanceof Error ? error : new Error(String(error)));
}
